export const NO_DELIVERY = 'Доставки нет'
export const TOAST_DURATION = 5000

export const DELIVERY_TYPES = {
    COURIER: 'courier',
    PICKUP: 'pickup',
}
